<h1 mat-dialog-title>{{'LINK.ERROR' | translate}}</h1>
<mat-dialog-content>
  <p>{{data.message | translate}}</p>
  <br/>
  <!--
  <hr>
  <p>{{'LINK.RESOLVEDLINK' | translate}}</p>
  <div class ="linkText">{{data.linktext}}</div>
  <hr>
  -->
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{'DIALOGS.OK' | translate}}</button>
</mat-dialog-actions>
